import React, {
  memo,
  forwardRef,
  useImperativeHandle,
  useRef,
  useMemo,
  useState,
  useCallback,
  useEffect,
} from 'react';
import { Col, Form, Input, Select } from 'antd';
import { Formik, FormikProps } from 'formik';
import * as yup from 'yup';
import { QuerySearch } from '../form/query-search';
import { GeneralApi, ModelApi } from '../../apis';
import { Dictionaries } from '../../interfaces';

const validationSchema = yup.object().shape({
  level: yup.string().required('Заавал оруулна'),
  carModelId: yup.string().required('Заавал оруулна'),
  extraPercent: yup.string().required('Заавал оруулна'),
  name: yup.string().required('Заавал оруулна'),
});

type FormValues = {
  name: string | undefined;
  carBrandId: string | undefined;
  level: string | undefined;
  carModelId: string | undefined;
  extraPercent: string | undefined;
};

type Props = {
  onSubmit: (values: any) => void;
  action: any;
};

export type BrandFormRef = {
  submitForm: () => any;
  getValues: () => any;
};

const OptionForm = memo(
  forwardRef<BrandFormRef, Props>(({ onSubmit: _onSubmit, action }, ref) => {
    const formikRef = useRef<FormikProps<FormValues>>(null);

    const [general, setGeneral] = useState<Dictionaries>();
    const loadData = useCallback(async () => {
      const res = await GeneralApi.init();
      setGeneral(res);
    }, []);

    useImperativeHandle(ref, () => ({
      submitForm: async () => {
        const validate = await formikRef.current?.submitForm();
        return validate;
      },
      getValues: () => {},
    }));

    const initialValues = useMemo(() => {
      console.log('action :', action);
      return {
        name: undefined,
        level: undefined,
        carModelId: undefined,
        extraPercent: undefined,
        carBrandId: undefined,
        ...(action && {
          name: action.name,
          level: action.level,
          carModelId: action.carModelId,
          carBrandId: action?.carBrandId,
          extraPercent: action.extraPercent,
        }),
      };
    }, [action]);

    useEffect(() => {
      loadData();
    }, [loadData]);

    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={_onSubmit}
        innerRef={formikRef}
      >
        {({ handleChange, values, errors, touched, setFieldValue }) => {
          console.log('errors :', errors);
          return (
            <>
              <Form layout="vertical">
                <div className="card">
                  <div className="inputContainer">
                    <div className="flex flex-row">
                      <div className="flex-1">
                        <Col flex={12}>
                          <Form.Item
                            label="Загвар"
                            layout="vertical"
                            validateStatus={errors.carModelId && touched.carModelId ? 'error' : ''}
                            help={
                              errors.carModelId && touched.carModelId
                                ? errors.carModelId
                                : ('' as any)
                            }
                          >
                            <QuerySearch
                              payload={{ carBrandId: values.carBrandId }}
                              value={values.carModelId}
                              onChange={(e) => setFieldValue('carModelId', e)}
                              placeholder="Загвар хайх"
                              showSearch
                              loadData={ModelApi.select}
                            />
                          </Form.Item>
                        </Col>
                        <Col flex={12}>
                          <Form.Item
                            label="Нэр"
                            layout="vertical"
                            validateStatus={errors.name && touched.name ? 'error' : ''}
                            help={errors.name && touched.name ? errors.name : ('' as any)}
                          >
                            <Input
                              name="name"
                              value={values.name}
                              onChange={handleChange}
                              placeholder="Нэр"
                              status={touched.name && errors.name ? 'error' : ''}
                            />
                          </Form.Item>
                        </Col>
                        <Col flex={12}>
                          <Form.Item
                            label="Зэрэглэл"
                            layout="vertical"
                            validateStatus={errors.level && touched.level ? 'error' : ''}
                            help={errors.level && touched.level ? errors.level : ('' as any)}
                          >
                            <Select
                              placeholder="Зэрэглэл"
                              value={values.level}
                              onChange={(e) => setFieldValue('level', e)}
                              options={general?.optionLevels.map((e) => ({
                                label: e.name,
                                value: e.code,
                              }))}
                              status={touched.level && errors.level ? 'error' : ''}
                            ></Select>
                          </Form.Item>
                        </Col>

                        <Col flex={12}>
                          <Form.Item
                            label="Хувь"
                            layout="vertical"
                            validateStatus={
                              errors.extraPercent && touched.extraPercent ? 'error' : ''
                            }
                            help={
                              errors.extraPercent && touched.extraPercent
                                ? errors.extraPercent
                                : ('' as any)
                            }
                          >
                            <Input
                              name="extraPercent"
                              value={values.extraPercent}
                              onChange={handleChange}
                              placeholder="Хувь"
                              status={touched.extraPercent && errors.extraPercent ? 'error' : ''}
                            />
                          </Form.Item>
                        </Col>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="h-[20px]" />
              </Form>
            </>
          );
        }}
      </Formik>
    );
  })
);

OptionForm.displayName = 'OptionForm';

export { OptionForm };
